"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var StringUtils_1 = require("../../Utils/StringUtils");
var XmlNodeList = /** @class */ (function (_super) {
    __extends(XmlNodeList, _super);
    //private m_nodes: Array<XmlNode>
    /**
     *
     */
    function XmlNodeList() {
        var _newTarget = this.constructor;
        var nodes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            nodes[_i] = arguments[_i];
        }
        var _this = _super.apply(this, nodes) || this;
        // if (nodes!=null)
        //     super(nodes);
        // else
        //     super();
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
        // if (nodes==null || nodes.length==0)
        //     this.m_nodes=new Array<XmlNode>();
        // else
        //     this.m_nodes=Array.from(nodes);
    }
    XmlNodeList.prototype.count = function () {
        return this.length;
    };
    XmlNodeList.prototype.get = function (Index) {
        return this[Index];
    };
    XmlNodeList.prototype.addNode = function (node) {
        this.push(node);
    };
    XmlNodeList.prototype.exist = function (nodeName, attrName, attrValue) {
        var bFound = false;
        this.forEach(function (node) {
            if (StringUtils_1.default.areEquals(node.getName(), nodeName) && node.attrExists(attrName) && StringUtils_1.default.areEquals(node.getAttrValue(attrName), attrValue))
                bFound = true;
        });
        return bFound;
    };
    XmlNodeList.prototype.clear = function () {
        while (this.length > 0)
            this.pop();
    };
    return XmlNodeList;
}(Array));
exports.default = XmlNodeList;

//# sourceMappingURL=XmlNodeList.js.map
